import api from '../api';

import { ParamsBodyObtainUserLogin } from 'utils/typeServices';

type ParamsResponse = {
    Data: boolean;
}

export const PostObtainUserLogin = async ({ body, sendObtainUser }: { body: ParamsBodyObtainUserLogin, sendObtainUser: boolean }) => {
    const bodyJson = JSON.stringify({
        document: body.document,
        plate: body.plate,
        chassi: body.chassi,
        zipCode: body.zipCode,
    });

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Cliente/ValidateClient', bodyJson);

        if (data) {
            if (sendObtainUser) {
                const { data: response } = await api.post<{ Data: string }>('/v2/Cliente/ObterLoginUsuario', bodyJson);

                return { data: response.Data };
            } else {
                return { data: data.Data };
            }
        } else {
            return { data: null };
        }
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
